import { render, staticRenderFns } from "./tableVariation.vue?vue&type=template&id=80f77ac8&scoped=true&lang=pug"
import script from "./tableVariation.vue?vue&type=script&lang=js"
export * from "./tableVariation.vue?vue&type=script&lang=js"
import style0 from "./tableVariation.vue?vue&type=style&index=0&id=80f77ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f77ac8",
  null
  
)

export default component.exports